<div class="modal-container" data-testid="information-modal">
  <div class="modal-header">
    <span>{{ data.headerText }}</span>
  </div>
  <div class="seperator">
    <hr />
  </div>
  <div class="modal-body">
    <div>
      <pre>{{ data.bodyText }}</pre>
    </div>
    <div class="modal-content">
      <div class="buttons">
        <ng-container *ngIf="data.cancelable">
          <app-button
            (click)="abortModal(true)"
            [small]="true"
            [title]="data.cancelButtonText || ('modal.info.cancel' | translate)"
            testId="information-modal-cancel"
          ></app-button>
        </ng-container>
        <app-button
          (click)="abortModal(false)"
          [small]="true"
          [title]="data.confirmButtonText || ('modal.info.ok' | translate)"
          testId="information-modal-confirm"
        ></app-button>
      </div>
    </div>
  </div>
</div>
